<template>
    <section v-if="isContentReady">
        <div class="row">
            <div class="col-12">
                <job-claim-step :loadData="loadData"></job-claim-step>
            </div>
        </div>

        <div class="row" v-show="isShowHeader">
            <div class="col-12">
                <job-claim-header :loadData="loadData">ใบเคลม</job-claim-header>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <job-claim-bill
                    v-show="isShowLookupClaim"
                    @selectPurchased="selectPurchased($event)"
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData">
                </job-claim-bill>
            </div>
        </div>

        <div id="panelCustomer" class="row" v-show="isShowClaimField">
            <div class="col-12">
                <job-claim-customer
                    ref="refCustomerData"
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-claim-customer>
            </div>
        </div>

        <div id="panelProduct" class="row" v-show="isShowClaimField">
            <div class="col-12">
                <job-claim-product
                    ref="refClaimProduct"
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-claim-product>
            </div>
        </div>

        <div id="panelPicture" class="row" v-show="isShowClaimField">
            <div class="col-12">
                <job-claim-picture
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-claim-picture>
            </div>
        </div>

        <div id="panelClaimResult" class="row" v-show="isShowClaimField">
            <div class="col-12">
                <job-claim-result
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-claim-result>
            </div>
        </div>

        <div class="text-center" v-if="isOpenJobAvailable">
            <button class="btn btn-main" @click="openJob()">เปิดใบเคลม</button>
        </div>
        <div class="text-center" v-if="jobState === $Constants.JOB_STATUS_PENDING">
            <button class="btn btn-blue mr-1" @click="mixinsJobForm_PrintForm()">PRINT ใบรับเคลม</button>
            <button class="btn btn-green mr-1" @click="saveJob()">บันทึกใบงาน</button>
            <button class="btn btn-main mr-1" @click="closeJob()">ปิดใบเคลม</button>
            <button class="btn btn-red ml-4" @click="cancelJob(loadData)">ยกเลิก</button>
        </div>

        <print-document ref="refPrintDocument" :printTemplate="$Constants.PRINT_TYPE_CLAIM"></print-document>
    </section>
</template>

<script>
import Helper from '@/resources/Helper';
import JobFormMixin from '@/components/job/JobForm';
import JobClaimStep from '@/components/job/claim/Step';
import JobClaimHeader from '@/components/job/shared/Header';
import JobClaimBill from '@/components/job/claim/Bill';
import JobClaimCustomer from '@/components/job/claim/Customer';
import JobClaimProduct from '@/components/job/claim/Product';
import JobClaimPicture from '@/components/job/claim/Picture';
import JobClaimResult from '@/components/job/claim/Result';
import PrintDocument from '@/components/print/PrintTemplate';
import DBJob from '@/database/Job';

export default {
    mixins: [ JobFormMixin ],
    components: {
        JobClaimStep,
        JobClaimHeader,
        JobClaimBill,
        JobClaimCustomer,
        JobClaimProduct,
        JobClaimPicture,
        JobClaimResult,
        PrintDocument
    },
    data() {
        return {
            isContentReady: false,
            formType: this.$Constants.JOB_FORM_CLAIM,
            isShowHeader: false,
            isShowLookupClaim: true,
            isOpenJobAvailable: false,
            isShowClaimField: false,
            jobState: this.$Constants.JOB_STATUS_NEW,
            loadData: null,
            errorData: null
        }
    },
    mounted() {
        this.initForm();
        this.initErrorData();
    },
    methods: {
        async initForm() {
            const queryStringOrder = Helper.getQueryString('o');

            if (queryStringOrder) {
                const data = await DBJob.getDetailByNumber(queryStringOrder, this.formType);

                if (data) {
                    this.isShowHeader = true;
                    this.isShowLookupClaim = false;
                    this.isShowClaimField = true;
                    this.jobState = data.status;
                    this.loadData = data;
                } else {
                    this.$router.push('/404');
                }
            }
            
            this.isContentReady = true;
        },
        initErrorData() {
            this.errorData = {
                customer: {
                    claimFirstName: { blank: false },
                    claimLastName: { blank: false },
                    claimTel: { blank: false }
                },
                product: {
                    dot: { blank: false },
                    price: { blank: false }
                },
                cause: { blank: false },
                picture: { blank: false },
                claim: {
                    result: { blank: false }
                }
            };
        },
        selectPurchased(data) {
            this.$refs.refCustomerData.bindClaimData(data);
            this.$refs.refClaimProduct.bindClaimData(data);

            this.isShowClaimField = true;
            this.isOpenJobAvailable = true;
        },
        openJob() {
            this.initErrorData();

            if (this.validateOpenJob()) {
                this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_OPEN, this.formType);

                this.$swal({
                    title: 'ต้องการออกใบเคลม?',
                    text: 'กดปุ่ม PRINT ใบเคลม',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'PRINT ใบเคลม',
                    cancelButtonText: 'กลับไปหน้ารายการ'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.mixinsJobForm_PrintForm();
                    } else {
                        this.$router.push('/job/list');
                    }
                });
                this.$swal({
                    title: 'เปิดใบเคลมเรียบร้อยแล้ว',
                    icon: 'success',
                    confirmButtonText: 'กลับไปหน้ารายการ'
                }).then(() => {
                    this.$router.push('/job/list');
                });

                this.jobState = this.$Constants.JOB_STATUS_COMPLETE;
            }
        },
        async saveJob() {
            this.initErrorData();

            if (this.validateOpenJob()) {
                this.mixinsJobForm_ProceedUpdateForm();
            }
        },
        closeJob() {
            this.initErrorData();

            if (this.validateCloseJob()) {
                this.$swal({
                    title: 'ได้รับผลเคลมเรียบร้อยแล้ว?',
                    text: 'โปรดยืนยันว่าต้องการปิดใบสั่งงานใบนี้',
                    icon: 'question',
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.mixinsJobForm_SaveForm(this.$Constants.JOB_ACTION_STATE_CLOSE, this.formType);

                        this.$swal({
                            title: 'ปิดใบเคลมเรียบร้อยแล้ว',
                            icon: 'success',
                            confirmButtonText: 'กลับไปหน้ารายการ'
                        }).then(() => {
                            this.$router.push('/job/list');
                        });

                        this.jobState = this.$Constants.JOB_STATUS_COMPLETE;
                    }
                });
            }
        },
        cancelJob(data) {
            this.mixinsJobForm_CancelJob(data);
        },
        validateOpenJob() {
            let valid = true;
            let isScrollDone = false;
            this.mixins_ResetScrollToError();

            if (!this.mixins_ValidateCustomerClaim()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelCustomer');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateProductClaim()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelProduct');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidatePictureClaim()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelPicture');
                    isScrollDone = true;
                }
            }

            return valid;
        },
        validateCloseJob() {
            let valid = true;
            let isScrollDone = false;
            this.mixins_ResetScrollToError();

            if (!this.mixins_ValidateCustomerClaim()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelCustomer');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateProductClaim()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelProduct');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidatePictureClaim()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelPicture');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateClaimResult()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelClaimResult');
                    isScrollDone = true;
                }
            }

            return valid;
        }
    }
}
</script>